/**
 * Curated list of industries offered in the onboarding flow's "Please select
 * your industry" step. The step is multi-select; selections are stored/sent as
 * a comma-separated string of `value`s.
 *
 * IMPORTANT: `value` must never contain a comma — selections are joined with
 * commas into a single payload string, so a comma inside one value would make
 * the list ambiguous. Where a `label` reads with commas (e.g. "Fintech,
 * InsurTech, RegTech"), the matching `value` uses " / " instead.
 */
export interface IndustryOption {
  value: string;
  label: string;
}

export const INDUSTRIES: IndustryOption[] = [
  { value: 'AI', label: 'AI' },
  { value: 'SaaS', label: 'SaaS' },
  { value: 'Healthcare & MedTech', label: 'Healthcare & MedTech' },
  { value: 'Fintech / InsurTech / RegTech', label: 'Fintech, InsurTech, RegTech' },
  { value: 'Climate & Energy', label: 'Climate & Energy' },
  { value: 'Deep Tech', label: 'Deep Tech' },
  { value: 'E-com / Retail & CPG', label: 'E-com, Retail & CPG' },
  { value: 'Education', label: 'Education' },
  { value: 'BioTech', label: 'BioTech' },
  { value: 'AgriTech & FoodTech', label: 'AgriTech & FoodTech' },
  { value: 'Future of Work / HR Tech', label: 'Future of Work / HR Tech' },
  { value: 'Blockchain / Crypto', label: 'Blockchain / Crypto' },
  {
    value: 'Media / Entertainment / Gaming & Sports',
    label: 'Media, Entertainment, Gaming & Sports',
  },
  { value: 'Hardware & Robotics', label: 'Hardware & Robotics' },
  { value: 'Marketplaces', label: 'Marketplaces' },
  { value: 'PropTech & Real Estate', label: 'PropTech & Real Estate' },
  { value: 'Mobility & Supply Chain', label: 'Mobility & Supply Chain' },
  { value: 'Cybersecurity', label: 'Cybersecurity' },
  { value: 'Marketing / AdTech', label: 'Marketing / AdTech' },
  { value: 'Tourism & Hospitality', label: 'Tourism & Hospitality' },
  { value: 'SpaceTech', label: 'SpaceTech' },
  { value: 'Other', label: 'Other' },
];
